export const environment = {
  fr: {
    headline: "Vous désirez diviser immédiatement l'impact carbone par 2 ?",
    title: "Formulation en béton bas carbone",
    line1:
      "Demandez notre Précoffré Thermique avec la solution en béton d'argile non calcinée.",
    link: {
      title: "Fehr x Materrup : béton d'argile non calcinée",
      url: "/beton/argile-non-calcinee-matterup/",
    },
    line2: "Départ usine, sans remplissage*",
    asterix: "*possibilité de remplissage avec du béton super bas carbone",
    carbonReduction: [
      {
        name: "Bas Carbone",
        reduction: "-34%",
      },
      {
        name: "Super bas carbone",
        reduction: "-40%",
      },
    ],
    avantages: [
      "Pas d’huile de coffrage : chantier propre",
      "Réduction des nuisances sur chantier et gênes aux riverains",
      "Pas de chantier encombré",
      "Pas de déchet",
    ],
  },
  de: {
    headline: "Umwelt",
    title: "Kohlenstoffarmer Beton :",
    line1: "Umweltauswirkung auf die Thermowand ",
    link: {
      title: "Fehr x Materrup",
      url: "/de/materrup-nicht-kalzinierter-ton/",
    },
    line2: "Ab Werk, unverfüllt*",
    asterix: "*Kann mit besonders kohlenstoffarmem Beton verfüllt werden",
    carbonReduction: [
      {
        name: "Kohlenstoffarm",
        reduction: "-34%",
      },
      {
        name: "Besonders kohlenstoffarm",
        reduction: "-40%",
      },
    ],
    avantages: [
      "Kein Schalöl: saubere Baustelle",
      "Weniger Belastungen auf der Baustelle und weniger Belästigung für die Anwohner",
      "Kein Flächenbedarf auf der Baustelle",
      "Keine Abfälle",
    ],
  },
  en: {
    headline: "Environment",
    title: "Low-carbon concrete formulation:",
    line1: "Environmental impact of Precast WallEx-works",
    link: {
      title: "Fehr x Materrup : béton d'argile non calcinée",
      url: "/beton/argile-non-calcinee-matterup/",
    },
    line2: "with no infill*",
    asterix: "*may be filled with super low carbon concrete",
    carbonReduction: [
      {
        name: "Low carbon",
        reduction: "-34%",
      },
      {
        name: "Super low carbon",
        reduction: "-40%",
      },
    ],
    avantages: [
      "No form release oil, for a cleaner site",
      "Reduced negative impacts of the work and nuisance to neighbours",
      "No clutter on the site",
      "No waste",
    ],
  },
}
